import { roundCurrency } from './format';

function clampPct(value) {
  const n = parseFloat(value);
  if (!Number.isFinite(n)) return 0;
  return Math.min(100, Math.max(0, n));
}

/**
 * Promo first, then manual discount, then tax on reduced base, then optional delivery.
 */
export function computeOrderTotals({
  itemsSubtotal,
  promoPct = 0,
  discountPct = 0,
  taxPct = 0,
  deliveryFee = 0,
  includeDeliveryInTotal = false,
}) {
  const subtotal = parseFloat(itemsSubtotal) || 0;
  const promo = clampPct(promoPct);
  const discount = clampPct(discountPct);
  const tax = clampPct(taxPct);
  const delivery = parseFloat(deliveryFee) || 0;

  const afterPromo = subtotal * (1 - promo / 100);
  const afterDiscount = afterPromo * (1 - discount / 100);
  const taxAmount = tax > 0 ? roundCurrency(afterDiscount * (tax / 100)) : 0;
  const itemsWithTax = afterDiscount + taxAmount;
  const total = includeDeliveryInTotal
    ? roundCurrency(itemsWithTax + delivery)
    : roundCurrency(itemsWithTax);

  const priceRatio = (1 - promo / 100) * (1 - discount / 100);

  return {
    afterPromo,
    afterDiscount,
    taxAmount,
    itemsWithTax,
    total,
    priceRatio,
    promoAmount: roundCurrency(subtotal - afterPromo),
    discountAmount: roundCurrency(afterPromo - afterDiscount),
  };
}

export function parseStorePromo(promoRaw) {
  if (promoRaw == null) return { promoName: null, promoPct: 0 };
  let promo = promoRaw;
  if (typeof promo === 'string') {
    try {
      promo = JSON.parse(promo);
    } catch {
      return { promoName: null, promoPct: 0 };
    }
  }
  if (!promo || typeof promo !== 'object' || Array.isArray(promo)) {
    return { promoName: null, promoPct: 0 };
  }
  const name = String(promo.name || '').trim();
  const pct = clampPct(promo.percentage);
  if (!name || pct <= 0) return { promoName: null, promoPct: 0 };
  return { promoName: name, promoPct: pct };
}

export function getOrderPriceRatio(order) {
  const promo = clampPct(order?.promo_percentage);
  const discount = clampPct(order?.discount_percentage);
  return (1 - promo / 100) * (1 - discount / 100);
}
